<template>
  <div id="page-index" ref="indexPage" class="hello">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <!--01-index-->
      <swiper-slide class="swiper-slide">
        <section id="section1" class="section">
          <header class="section-header">新零售场景赋能    传统零售业态重构</header>
          <p class="section-subtitle">专注于AI与IoT技术领域，提供全球领先的新零售人工智能解决方案</p>
          <img src="../assets/index-vendor.png" alt="" class="index-vendor">
        </section>
      </swiper-slide>
      <!--02-行业机会-->
      <swiper-slide class="swiper-slide">
        <section id="section2" class="section">
          <header class="section-header">行业机会</header>
          <p class="section-subname">OPPORTUNITY</p>
          <div class="section2-box">
            <div class="container" v-for="(v ,i) in opportunity" :key="i">
              <img :src="v.img" alt="" class="opportunity-img">
              <div class="footer">
                <div class="left">{{v.title}}</div>
                <ul class="right" v-for="(tag ,i) in v.tags" :key="i"><li>·{{tag}}</li></ul>
              </div>
            </div>
          </div>
        </section>
      </swiper-slide>
      <!--03-设备-->
      <swiper-slide class="swiper-slide">
        <section id="section3" class="section">
          <img class="section3-left" src="../assets/index-left.png" alt="" @click="togglePic(false)">
          <img class="section3-right" src="../assets/index-right.png" alt="" @click="togglePic(true)">
          <div v-for="(v, i) in vendorsImg" :key="i"  v-if="index === v.index">
            <header class="section-header">{{v.size}}</header>
            <img class="vendor-img"  :src="v.url" alt="">
          </div>
        </section>
      </swiper-slide>
      <!--04-行业机会-->
      <swiper-slide class="swiper-slide">
      <section id="section4" class="section">
        <header class="section-header">行业机会</header>
        <p class="section-subname">OPPORTUNITY</p>
        <p class="section-subtitle">无人零售货柜产品升级  新零售消费场景改造  为传统零售行业赋能</p>
        <img src="/static/index-scene.png"/>
      </section>
    </swiper-slide>
      <!--05-使用流程 -->
      <swiper-slide class="swiper-slide">
        <section id="section5" class="section">
          <header class="section-header">使用流程</header>
          <p class="section-subname">USE PROCESS</p>
          <p class="section-subtitle">识人开门 任意拿取 关门识别 自动结算</p>
          <img src="../assets/scroll-index-05.png"/>
          <!-- <p><button class="btn-detail">查看详情</button></p> -->
        </section>
      </swiper-slide>
      <!--06-解决方案-->
      <swiper-slide class="swiper-slide">
      <section id="section6" class="section">
        <header class="section-header">解决方案</header>
        <p class="section-subname">SOLUTION</p>
        <img src="../assets/solution.png"/>
        <!-- <p><button class="btn-detail">详细了解</button></p> -->
      </section>
    </swiper-slide>
      <!--07-关于我们-->
      <swiper-slide class="swiper-slide">
        <section id="section7" class="section">
          <header class="section-header">关于我们</header>
          <p class="section-subname">ABOUT US</p>
          <div class="containers">
            <div class="team-pics">
              <div class="left">
                <img src="/static/aboutus-01.png"/>
              </div>
              <div class="middle">
                <img class="top" src="/static/aboutus-02.png"/>
                <img src="/static/aboutus-03.png"/>
              </div>
              <div class="right">
                <img src="/static/aboutus-04.png"/>
              </div>
            </div>
          </div>
          <div class="team-desc">
            <p>弦熵科技潜心于大数据、云计算、物联网、人工智能等领域的科技创新。业态和模式的创新，商品和服务的创新。通过信息技术的创新，可以降低物流成本、经营成本、管理成本、提高
              坪效比、提高竞争能力；通过技术的创新，可以有力推动业态和模式的创新；通过业态和模式的创新，可以更好地满足消费者多样化、多层次化、多方面化和个性化的需求；通过商品和服
              务的创新，可以刺激潜在的消费，提高边际消费率、扩大消费。</p>
          </div>
        </section>
      </swiper-slide>
      <!--08-合作伙伴-->
      <swiper-slide class="swiper-slide">
        <section id="section8" class="section">
          <header class="section-header">合作伙伴</header>
          <p class="section-subname">COOPERATIVE PARTNER</p>
          <div class="containers">
            <img v-for="(v, i) in partner" :src="v" :key="i" alt="" class="brand">
          </div>
          <!--<img src="../assets/solution.png"/>-->
        </section>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'index',
  data () {
    return {
      index: 0,
      partner: [
        '../../static/parnter-ali.png',
        '../../static/parnter-google.png',
        '../../static/parnter-huawei.png',
        '../../static/parnter-interl.png',
        '../../static/parnter-jd.png',
        '../../static/parnter-rongshida.png',
        '../../static/parnter-tecent.png',
        '../../static/parnter-w3c.png',
        '../../static/parnter-wanda.png',
        '../../static/parnter-wechat.png',
        '../../static/parnter-yida.png',
        '../../static/partner-guomei.png'
      ],
      list: [],
      swiperOption: {
        notNextTick: false, // 不知道是啥
        direction: 'vertical', // 轮播方向
        // grabCursor: true, // 设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。
        setWrapperSize: true, // 开启这个设定会在Wrapper上添加等于slides相加的宽高，在对flexbox布局的支持不是很好的浏览器中可能需要用到
        // autoHeight: true, // wrapper和container会随着当前slide的高度而发生变化。
        slidesPerView: 1, // 每次滑动的页数
        mousewheel: true, // 开启鼠标滑轮
        height: window.innerHeight, // 强制Swiper的高度(px)，当你的Swiper在隐藏状态下初始化时且切换方向为垂直才用得上。这个参数会使自适应失效。
        resistanceRatio: 0.8, // 抵抗力 越大越南移动 值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。
        observeParents: true
      },
      msg: '',
      opportunity: [
        {
          img: '../../static/index-opportunity-01.png',
          title: '成绩',
          tags: [
            '中国第一台非RFID智能货柜',
            '中国第一台动态识别智能货柜',
            '中国第一台多维度AI识别货柜'
          ]
        },
        {
          img: '../../static/index-opportunity-02.png',
          title: '优势',
          tags: [
            '支持商品堆叠码放、自定义码放',
            '可售标品、半标品、非标品',
            '重力、动态、决策脑一秒识别'
          ]},
        {
          img: '../../static/index-opportunity-03.png',
          title: '方向',
          tags: [
            '新零售场景赋能',
            '传统零售业态重构',
            '人货场形态全面升级'
          ]
        }
      ],
      vendorsImg: [
        {url: '../../static/vendor-A386WVg.png', index: 0, size: 'A386WV-V'},
        {url: '../../static/vendor-A386WVg.png', index: 1, size: 'A386WV-G'},
        {url: '../../static/vendor-A386WVg.png', index: 2, size: 'X398F-VGB'},
        {url: '../../static/vendor-X810F-VGB.png', index: 3, size: 'X810F-VGB'}

      ]
    }
  },
  methods: {
    togglePic (direction) {
      if (direction) {
        if (this.index < this.vendorsImg.length - 1) {
          this.index++
        } else {
          this.index = 0
        }
      } else {
        if (this.index <= 0) {
          this.index = this.vendorsImg.length - 1
        } else {
          this.index--
        }
      }
    }
  },
  mounted () {
    // document.body.scrollTop = 0
    // document.documentElement.scrollTop = 0
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-index {
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1280px;
  ul {
    height: 100%;
    list-style: none;
    margin: 0;
    padding-left: 0;
  }
  ul li {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    /*list-style: circle;*/
    /*padding-top: 70px;*/
  }
  .section-header {
    color: #333333;
    font-size: 42px;
    padding-top: 6%;
    font-weight: 800;
  }
  .section-subtitle {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333333;
  }
}
.section {
  height: 100vh;
  background-size: cover;
  background-position: center;
  min-width: 1280px;
}
#section1 {
  box-sizing: border-box;
  padding-top: 2%;
  position: relative;
  background-image: url("../assets/scroll-index-01.png");
  background-repeat: no-repeat;
  background-size: cover;
  .index-vendor {
    width: 16%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

}
#section2 {
    box-sizing: border-box;
    padding-top: -1%;
    position: relative;
    background-image: url("../assets/scroll-index-02.png");
    background-repeat: no-repeat;
    background-size: cover;
  .section-subname {
    font-size: 14px;
    margin: 0;
    margin-bottom: 2%;
  }
    .section-subtitle {
      margin-top: 10px;
      margin-bottom: 70px;
      font-size: 15px;
      color: #333333;
    }
    .section2-box {
      width: 100%;
      height: 80%;
      display: flex;
      justify-content: center;
      .container {
        width: 20%;
        height: 65%;
        background-color: #fff;
        margin: 20px;
        margin-top: 0;
        padding: 0;
        .opportunity-img {
          width: 100%;
        }

        .footer {
          width: 100%;
          height: 28%;
        }
        .left {
          width: 20px;
          font-size: 35px;
          margin-top: 6%;
          margin-left: 10%;
          float: left;
        }
        .right {
          width: 90%;
          margin-left: 20px;
          padding-left: 20%;
          padding-top: 7.5%;
          text-align: left;
          height: 30px;
          font-size: 16px;
        }
      }
    }
  }
#section3 {
  position: relative;
  height: 100vh;
  padding: 1px;
  box-sizing: border-box;
  background-image: url("../assets/scroll-index-03.png");
  .section3-left {
    position: absolute;
    left: 10%;
    top: 40%;
    opacity: .7;
    cursor: pointer;
  }
  .section3-right {
    position: absolute;
    right: 10%;
    top: 40%;
    opacity: .7;
    cursor: pointer;
  }
  .section3-left:hover,.section3-right:hover {
    opacity: 1;
  }
   .section-header {
     color: #888;
     font-size: 20px;
     font-weight: 400;
     margin-top: 4%;
   }
   .vendor-img {
     /*width: 20%;*/
     /*height: 10%;*/
     height: 600px;
     margin-top: 3%;
   }
 }
#section4 {
  background-image: url("../assets/scroll-index-04.png");
  .section-subname {
    font-size: 14px;
    margin: 0;
    margin-bottom: 2%;
  }
  .section-subtitle:nth-child(2) {
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 15px;
    color: #333333;
  }
  .section-subtitle:nth-child(3) {
    margin-bottom: 4%;
    font-size: 17px;
  }
  img {
    width: 60%;
  }
}
#section5 {
  background-image: url("../assets/scroll-index-05b.png");
  .section-subname {
    font-size: 14px;
    margin: 0;
  }
  .section-subtitle:nth-child(3) {
    margin-bottom: 4%;
    font-size: 18px;
  }
  img {
    width: 70%;
  }
  .btn-detail {
    margin-top: 5%;
    color: white;
    background-color: #3692fb;
    border: none;
    border-radius: 3px;
    width: 100px;
    height: 35px;
  }

}
#section6 {
  background-image: url("../assets/scroll-index-06.png");
  .section-subname {
    font-size: 14px;
    margin: 0;
  }
  .section-subtitle:nth-child(3) {
    margin-bottom: 4%;
    font-size: 18px;
  }
  img {
    margin-top: 2%;
    width: 35%;
    margin-right: 25%;
  }
  .btn-detail {
    margin-top: 4%;
    color: white;
    background-color: #3692fb;
    border: none;
    border-radius: 3px;
    width: 100px;
    height: 35px;
  }

}
#section7 {
  background-image: url("../assets/scroll-index-07.png");
  .section-subname {
    font-size: 14px;
    /*margin-bottom: 1%;*/
    margin-top: 0;
  }
  .containers {
    margin: 0 auto;
    width: 55%;
    /*height: 40%;*/
    display: flex;
    justify-content: center;
    margin-top: 4%;
  }
  .team-pics {
    display: flex;
    justify-content: center;
    height: 57%;
  }
  .team-pics img {
    max-width: 100%;
    vertical-align: top;
  }

  .team-pics .left{
    flex: 36;
    margin-right: 20px;
    margin-top: 0;
  }
  .team-pics .middle{
    flex: 48;
  }
  .team-pics .right{
    margin-left: 20px;
    flex: 36;
  }
  .team-pics .top {
    margin-bottom: 20px;
  }
  .team-desc {
    margin: 2% auto;
    width: 55%;
    text-align: left;
    font-size: 14px;
    text-indent: 2em;
    p {
      margin: 0;
      line-height: 28px;

    }
  }
}
#section8 {
  background-image: url("../assets/scroll-index-08.png");
  .section-subname {
    font-size: 14px;
    margin: 0;
    margin-bottom: 2%;
  }
  .section-subtitle:nth-child(3) {
    margin-bottom: 4%;
    font-size: 18px;
  }
  .containers {
    margin: 0 auto;
    width: 55%;
    height: 51%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 5%;
  }
  .brand {

    width: 15%;
    height: 19%;
    float: left;
    margin-left: 1%;
    margin-top: 1%;
  }

}
@media only screen and (max-width: 1700px) and (min-width: 0px){
  .left {
    font-size: 25px!important;
    margin-top: 15px!important;
  }
  .right {
    padding-top: 15px!important;
    font-size: 13px!important;
    height: 25px!important;
  }
  #section3 .vendor-img{
    height: 450px;
  }
  #section7 .team-pics .top {
    margin-top: 16px;
  }
  #section7 .containers{
    margin-top: 0;
  }
  #section8 .brand {
    height: 15%;

  }
  #section8 .containers {
    margin-top: 1%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Index.vue